import comItem from '@/components/page/account/common/list/Item'

export default {

    props: ['item', 'text'],

    components: {
        'com-item': comItem
    }

}